export const SERVER_API = 'https://fabric.studioantya.com:4002';
//export const SERVER_API = 'http://localhost:8001';

export const ERP_URL = 'https://erp.studioantya.com';